<template>
    <div class="page_home">
        <!-- 首页 -->
        <!-- nav -->
        <!-- <index-top></index-top> -->
        <!-- 内容区 -->
        <div class="content">
            <img class="back" :src="adddom(adlist[6].ad[0].ad_thumb)" alt v-if="adlist[6] && adlist[6].ad" />
            <div class="inner">
                <!-- 公告 -->
                <!-- advert-top -->
                <div class="gonggao" v-if="tongList">
                    <div class="ico-horn">
                        <!-- 喇叭图标 -->
                        <img class="icon" src="/statics/image/index/tongzhi.png" alt @click="toTongzhi" />
                    </div>
                    <!-- 滚动文字区域 -->
                    <div class="marquee-wrap">
                        <ul class="marquee-box" id="marquee-box">
                            <li v-for="(item, index) in tongList" :key="index" class="marquee-list"
                                :id="index == 0 ? 'marquee' : ''" @click="toNewsInfo(35, item, item.article_id)">
                                {{ item.article_title }}
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- 导航 -->
                <!-- @click="toVideo" -->
                <!--  -->
                <div class="home_nav" v-if="
                    adlist[0] && adlist[0].ad && adlist[0] && adlist[0].ad.length <= 4
                ">
                    <a :href="item.ad_url" v-for="(item, index) in adlist[0].ad" :key="index" target="_blank">
                        <img :src="adddom(item.ad_thumb)" alt />
                    </a>
                </div>
                <div class="home_nav" v-if="
                    adlist[0] && adlist[0].ad && adlist[0] && adlist[0].ad.length > 4
                ">
                    <div class="swiper navSwiper swiper-no-swiping" v-if="adlist[0].ad.length > 0">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide" v-for="(item, index) in adlist[0].ad" :key="index">
                                <a :href="item.ad_url" target="_blank">
                                    <img :src="adddom(item.ad_thumb)" alt="pic" />
                                </a>
                            </div>
                        </div>
                        <div class="swiper-button-prev"></div>
                        <div class="swiper-button-next"></div>
                    </div>
                </div>

                <!-- 新闻标签 -->
                <div class="news_tabs">
                    <a :href="newsLian" class="more" @click="toNewsmore">
                        <span>更多</span>
                        <i class="el-icon-arrow-right"></i>
                    </a>
                    <!-- <div class="xiying">
            <span>中国共产党第二十次全国代表大会</span>
          </div>-->
                    <el-tabs v-model="activeNews" @tab-click="handleNew">
                        <el-tab-pane label="热门新闻" name="51"></el-tab-pane>
                        <el-tab-pane label="部门动态" name="24"></el-tab-pane>
                        <el-tab-pane label="媒体聚焦" name="25"></el-tab-pane>
                        <el-tab-pane label="国务要闻" name="5464"></el-tab-pane>
                        <!-- <el-tab-pane label="中国共产党第二十次全国代表大会" name="-1"></el-tab-pane> -->
                    </el-tabs>
                    <!-- <div class="news_list" v-if="article[newsTab] && article[newsTab].article">
            <div class="news_item" v-for="(item,index) in article[newsTab].article" :key="index"
              @click="toNewsInfo(item.article_id)">
              <div class="left">
                <img class="icon" src="/statics/image/index/dian.png" alt />
                <span class="title">{{item.article_title}}</span>
              </div>
              <div>
                <span class="time">{{item.publish_at}}</span>
              </div>
            </div>
          </div>-->
                    <!-- <iframe
            v-if="showGuoWu"
            src="http://www.gov.cn/pushinfo/v150203/base_14px_pubdate.htm"
            width="100%"
            height="100%"
            style="padding-bottom: 20px; padding-left: 20px; height: 290px;"
          ></iframe> -->
                    <div class="news_list" v-if="showGuoWu" id="gwy">
                    </div>
                    <div class="news_list" v-else-if="horNewsList">
                        <div class="news_item" v-for="(item, index) in horNewsList" :key="index"
                            @click="toNewsInfo(rotid, item, item.article_id)">
                            <div class="left">
                                <img class="icon" src="/statics/image/index/dian.png" alt />
                                <span class="title">{{ item.article_title }}</span>
                            </div>
                            <div>
                                <span class="time">{{ item.publish_at }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 导航 -->
                <div class="navList" v-if="adlist[1] && adlist[1].ad">
                    <!-- <a :href="item.ad_url" v-for="(item,index) in adlist[1].ad" :key="index" target="_blank">
            <img :src="adddom(item.ad_thumb)" alt />
          </a>-->
                    <div class="swiper daoSwiper swiper-no-swiping" v-if="adlist[1].ad.length > 0">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide" v-for="(item, index) in adlist[1].ad" :key="index">
                                <a :href="item.ad_url" target="_blank">
                                    <img :src="adddom(item.ad_thumb)" alt />
                                </a>
                            </div>
                        </div>
                        <div class="swiper-button-prev"></div>
                        <div class="swiper-button-next"></div>
                    </div>
                </div>
                <!-- 招标公告 -->
                <div class="news_tabs">
                    <a :href="gongLian" class="more" @click="toGongmore">
                        <span>更多</span>
                        <i class="el-icon-arrow-right"></i>
                    </a>
                    <el-tabs v-model="activeGong" @tab-click="handleGong">
                        <el-tab-pane label="招标公告" name="53"></el-tab-pane>
                        <el-tab-pane label="中标公告" name="52"></el-tab-pane>
                    </el-tabs>
                    <div class="news_list" v-if="gongList">
                        <div class="news_item" v-for="(item, index) in gongList" :key="index"
                            @click="toNewsInfo(gongid, item, item.article_id)">
                            <div class="left">
                                <img class="icon" src="/statics/image/index/dian.png" alt />
                                <span class="title">{{ item.article_title }}</span>
                            </div>
                            <div>
                                <span class="time">{{ item.publish_at }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 地址电话 -->
                <div class="home_tel" v-if="adlist[2] && adlist[2].ad">
                    <!-- <img src="/statics/image/index/home_tel.jpg" alt=""> -->
                    <img :src="adddom(adlist[2].ad[0].ad_thumb)" alt />
                </div>
                <!-- 投资环境 -->
                <div class="touzi">
                    <div class="left">
                        <div :class="tzId == item.cate_id ? 'act' : ''" v-for="(item, index) in touzi" :key="index"
                            @click="changeTz(item.cate_id, index)">
                            <span>{{ item.name }}</span>
                        </div>
                    </div>
                    <div class="right" v-if="touziList">
                        <div class="tz_item" v-for="(item, index) in touziList" :key="index"
                            @click="toNewsInfo(tzId, item, item.article_id)">
                            <span class="title">{{ item.article_title }}</span>
                            <span class="time">{{ item.publish_at }}</span>
                        </div>
                    </div>
                    <a :href="touLian" class="more" @click="toToumore">
                        <span>更多</span>
                        <i class="el-icon-arrow-right"></i>
                    </a>
                </div>
                <!-- 导航 -->
                <!-- <div class="nav_list" v-if="adlist[3]&&adlist[3].ad">
          -- <img src="/statics/image/index/nav1.png" alt="">
          <img src="/statics/image/index/nav2.png" alt="">
          <img src="/statics/image/index/nav3.png" alt="">
          <img src="/statics/image/index/nav4.png" alt="">
          <img src="/statics/image/index/nav5.png" alt="">--
          <img v-for="(item,index) in adlist[3].ad" :key="index" :src="adddom(item.ad_thumb)" alt />
        </div>-->
                <!-- 河北政务服务网 -->
                <div class="hebei" v-if="adlist[4] && adlist[4].ad">
                    <a :href="adlist[4].ad[0].ad_url" target="_blank">
                        <img :src="adddom(adlist[4].ad[0].ad_thumb)" alt />
                    </a>
                </div>
                <!-- 轮播 -->
                <div class="bottom">
                    <div class="left">
                        <div class="swiper mySwiper swiper-no-swiping" v-if="lunboList.length > 0">
                            <div class="swiper-wrapper">
                                <!-- @click="toNewsInfo(item,item.article_id)" -->
                                <div class="swiper-slide" v-for="(item, index) in lunboList" :key="index"
                                    :data-url="item.url" :data-flag="item.link_flag" :data-id="item.article_id">
                                    <div class="pic">
                                        <img :src="adddom(item.article_thumb)" alt="pic" />
                                    </div>
                                    <div class="lbcon">
                                        <span class="title">{{ item.article_title }}</span>
                                        <span class="desc slht">{{ item.article_describe }}</span>
                                    </div>
                                </div>
                            </div>
                            <!-- 导航按钮 -->
                            <div class="swiper-button-prev"></div>
                            <div class="swiper-button-next"></div>
                        </div>
                    </div>
                    <!-- 政府解读 -->
                    <div class="right" v-if="adlist[5] && adlist[5].ad">
                        <a :href="item.ad_url" v-for="(item, index) in adlist[5].ad" :key="index" target="_blank">
                            <img :src="adddom(item.ad_thumb)" alt />
                        </a>
                    </div>
                </div>
                <!-- 便民服务 -->
                <div class="news_tabs">
                    <el-tabs v-model="activeBian" @tab-click="handleBian">
                        <el-tab-pane label="便民服务" name="bian"></el-tab-pane>
                    </el-tabs>
                    <div class="bianList">
                        <a href="https://www.cctv.com/" target="_blank">
                            <img src="/statics/image/index/bm_pic1.png" alt />
                        </a>
                        <a href="https://www.hebnews.cn/" target="_blank">
                            <img src="/statics/image/index/bm_pic2.png" alt />
                        </a>
                        <a href="https://www.people.cn/" target="_blank">
                            <img src="/statics/image/index/bm_pic3.png" alt />
                        </a>
                        <a href="https://www.samr.gov.cn/" target="_blank">
                            <img src="/statics/image/index/bm_pic4.png" alt />
                        </a>
                        <a href="http://hbrb.hebnews.cn/pc/paper/layout/201907/08/node_01.html" target="_blank">
                            <img src="/statics/image/index/bm_pic5.png" alt />
                        </a>
                        <a href="https://www.hsrb.com.cn/" target="_blank">
                            <img src="/statics/image/index/bm_pic6.png" alt />
                        </a>
                        <a href="http://www.hebei.com.cn/" target="_blank">
                            <img src="/statics/image/index/bm_pic7.png" alt />
                        </a>
                        <a href="https://www.cctv.com/" target="_blank">
                            <img src="/statics/image/index/bm_pic8.png" alt />
                        </a>
                    </div>
                </div>
            </div>
            <!-- 左侧广告 -->
            <div class="leftAd" v-show="leftAd == 1" v-if="adlist[7] && adlist[7].ad">
                <span @click="toclosel">关闭</span>
                <!-- <img src="/statics/image/index/leftAd1.png" alt="">
        <img src="/statics/image/index/leftAd2.png" alt="">
        <img src="/statics/image/index/leftAd3.png" alt="">
        <img src="/statics/image/index/leftAd4.png" alt="">-->
                <img v-for="(item, index) in adlist[7].ad" :key="index" :src="adddom(item.ad_thumb)" alt
                    @click="toleftAd(item.ad_url)" />
            </div>
            <!-- 右侧广告 -->
            <div class="rightAd" v-show="rightAd == 1" v-if="adlist[8] && adlist[8].ad">
                <span @click="tocloser">关闭</span>
                <!-- <img src="/statics/image/index/rightAd1.png" alt="">
        <img src="/statics/image/index/rightAd2.png" alt="">
        <img src="/statics/image/index/rightAd3.png" alt="">-->
                <img v-for="(item, index) in adlist[8].ad" :key="index" :src="adddom(item.ad_thumb)" alt
                    @click="torightAd(item.ad_url)" />
            </div>
        </div>
        <!-- footer -->
        <FloatingWindow :item="floatingItem" :height="384" :width="216"></FloatingWindow>
        <!-- <index-footer></index-footer> -->
    </div>
</template>

<script>
// import indexTop from "./../components/top";
// import indexFooter from "./../components/footer";
import FloatingWindow from "./../components/FloatWidow";
export default {
    name: "home",
    data() {
        return {
            contents: "",
            timer: null,
            // act:true,
            isFirst: false,
            tongList: [], //通知
            horNewsList: [], //热门新闻列表
            gongList: [], //公告列表
            rotid: "51",
            gongid: "53",
            activeNews: "51", //热门新闻标签
            activeGong: "53", //招标公告标签
            activeBian: "bian", //便民服务标签
            // touzi: ["投资环境", "投资程序", "投资政策", "投资成果"],
            touzi: [
                {
                    name: "投资环境",
                    cate_id: "31",
                },
                {
                    name: "投资程序",
                    cate_id: "33",
                },
                {
                    name: "投资政策",
                    cate_id: "32",
                },
                {
                    name: "投资成果",
                    cate_id: "34",
                },
            ],
            tzId: "31",
            touziList: [],
            tzIndex: 0, //投资环境选中下标
            leftAd: 1, //左侧广告1显示0关闭
            rightAd: 1, //右侧广告1显示0关闭
            article: [], //文章列表
            adlist: [], //广告列表
            newsTab: 2,
            zbTab: 10,
            tzTab: 3,
            newsLian: "",
            gongLian: "",
            touLian: "",
            lunboList: [],
            showGuoWu: false,
            catelist: [],
            // floatingItem: {
            //   id: 1,
            //   href: "http://syshj1.hebyg.cn/notice/index.html",
            //   image: "/statics/image/xuanfuk.jpg"
            // }
            floatingItem: {},
        };
    },
    components: {
        // indexTop,
        // indexFooter,
        FloatingWindow
    },
    created() {
        console.log("created");
        // if (localStorage.getItem("topvalue")) {
        //   localStorage.removeItem("topvalue");
        // }
        this.getHome();
        this.getNav();
    },
    methods: {
        toNewsmore() {
            // console.log(this.activeNews);
            if (this.activeNews == 51) {
                this.newsLian = this.$url + "/#/xqNews?id=12&index=1&dhid=51";
            } else if (this.activeNews == 24) {
                this.newsLian = this.$url + "/#/xqNews?id=12&index=1&dhid=24";
            } else if (this.activeNews == 25) {
                this.newsLian = this.$url + "/#/xqNews?id=12&index=1&dhid=25";
            } else if (this.activeNews == 5464) {
                // this.newsLian = "http://gwh_h5.shanmuzhi.com/xqNews?id=12&index=1&dhid=5464";
                this.newsLian = "http://www.gov.cn/zhengce/#/index.htm";
            }
        },
        toGongmore() {
            // console.log(this.activeGong);
            if (this.activeGong == "53") {
                this.gongLian = this.$url + "/#/xqNews?id=14&index=5&dhid=53";
            } else if (this.activeGong == "52") {
                this.gongLian = this.$url + "/#/xqNews?id=14&index=5&dhid=52";
            }
        },
        toToumore() {
            // console.log(this.tzIndex);
            if (this.tzIndex == 0) {
                this.touLian = this.$url + "/#/xqNews?id=13&index=2&dhid=31";
            } else if (this.tzIndex == 1) {
                this.touLian = this.$url + "/#/xqNews?id=13&index=2&dhid=33";
            } else if (this.tzIndex == 2) {
                this.touLian = this.$url + "/#/xqNews?id=13&index=2&dhid=32";
            } else if (this.tzIndex == 3) {
                this.touLian = this.$url + "/#/xqNews?id=13&index=2&dhid=34";
            }
        },
        toNewsInfo(cate_id, item, id) {
            // console.log("item",item);
            if (item.link_flag == 1) {
                window.open(item.url);
            } else {
                this.$router.push({
                    path: "/xqNews_detail",
                    query: {
                        cate_id: cate_id,
                        id: id,
                    },
                });
            }
        },
        // toVideo() {
        //   this.$router.push({
        //     path: "/video",
        //     query: {
        //       cate_id: 1
        //     }
        //   });
        // },
        // 图片拼接地址
        adddom(src) {
            if (src == "" || src == undefined || src == null) {
                console.log("src地址有问题");
                return "";
            }
            if (src.substr(0, 4).toLowerCase() === "http") {
                return src;
            }
            return this.$url + src;
        },
        getNav() {
            var that = this;
            that.$api.index.catelist({}).then(function (res) {
                if (res.code == 200) {
                    that.catelist = res.result.all_cate;
                }
            });
        },
        // 首页接口
        getHome() {
            var that = this;
            that.$api.index.index({}).then(function (res) {
                if (res.code == 200) {
                    that.adlist = res.result.adlist;
                    that.article = res.result.article;
                    if (that.adlist && that.adlist[11].ad) {
                        that.floatingItem = that.adlist[11];
                    }
                    for (var i in that.article) {
                        if (that.article[i].cate_id == "35") {
                            that.tongList = that.article[i].article
                                ? that.article[i].article
                                : [];
                            // console.log("tong", this.tongList);
                        }
                        if (that.article[i].cate_id == that.rotid) {
                            that.horNewsList = that.article[i].article
                                ? that.article[i].article
                                : [];
                        }
                        if (that.article[i].cate_id == that.gongid) {
                            that.gongList = that.article[i].article
                                ? that.article[i].article
                                : [];
                        }
                        if (that.article[i].cate_id == that.tzId) {
                            that.touziList = that.article[i].article
                                ? that.article[i].article
                                : [];
                        }
                        if (that.article[i].cate_id == "40") {
                            that.lunboList = that.article[i].article
                                ? that.article[i].article
                                : [];
                        }
                    }

                    // 通知公告滚动
                    setTimeout(() => {
                        that.runMarquee();
                    }, 1000);
                }
            });
        },
        // 通知公告滚动
        runMarquee() {
            // 获取文字 计算后宽度
            // var width = document.getElementById('marquee').getBoundingClientRect().width,
            var width = document.getElementById("marquee-box").getBoundingClientRect()
                .width,
                marquee = document.getElementById("marquee-box"),
                disx = 0; // 位移距离
            //设置位移
            setInterval(() => {
                disx--; // 滚动步长
                // console.log(-disx,width);
                if (-disx >= width) {
                    disx = 1000; // 如果位移超过文字宽度，则回到起点  marquee-list的margin值
                }
                marquee.style.left = disx + "px";
            }, 30); //滚动速度
        },
        // 新闻标签切换
        handleNew(tab, event) {
            // console.log(tab.name);
            if (tab.name == "5464") {
                // this.rotid = "5464";
                this.clickGuowu();
                return;
            }
            // if(tab.name == "-1"){
            //   window.open("http://www.gov.cn/zhuanti/zggcddescqgdbdh/index.htm", '_self');
            // // window.open("http://www.gov.cn/zhuanti/zggcddescqgdbdh/index.htm", '_blank');
            //   return;
            // }
            this.showGuoWu = false;
            $("#gwy").html('')
            if (tab.name == "51") {
                this.rotid = "51";
            } else if (tab.name == "24") {
                this.rotid = "24";
            } else if (tab.name == "25") {
                this.rotid = "25";
            }
            for (var i in this.article) {
                if (this.article[i].cate_id == this.rotid) {
                    this.horNewsList = this.article[i].article
                        ? this.article[i].article
                        : [];
                }
            }
            this.$forceUpdate();
            // this.getHome();
        },
        clickGuowu() {
            this.showGuoWu = true;
            //   console.log($("#gwy"))
            //   console.log(this.contents)
            let that = this
            setTimeout(function () {
                $("#gwy").html(that.contents)
            }, 300)

            // var that = this;
            // that.$api.index.guowulist({}).then(function (res) {
            //   console.log('guowulist:',res)
            // });
        },
        // 公告标签切换
        handleGong(tab, event) {
            // console.log(tab.name);
            if (tab.name == "53") {
                this.gongid = "53";
            } else if (tab.name == "52") {
                this.gongid = "52";
            }
            for (var i in this.article) {
                if (this.article[i].cate_id == this.gongid) {
                    this.gongList = this.article[i].article
                        ? this.article[i].article
                        : [];
                }
            }
        },
        // 便民服务标签切换
        handleBian(tab, event) { },
        // 切换投资
        changeTz(id, index) {
            this.tzIndex = index;
            this.tzId = id;
            // if (this.tzId == "31") {
            //   // this.tzTab = 3;
            // } else if (this.tzId == "33") {
            //   // this.tzTab = 5;
            // } else if (this.tzId == "32") {
            //   // this.tzTab = 4;
            // } else if (this.tzId == "34") {
            //   // this.tzTab = 6;
            // }
            for (var i in this.article) {
                if (this.article[i].cate_id == this.tzId) {
                    this.touziList = this.article[i].article
                        ? this.article[i].article
                        : [];
                }
            }
        },
        // 关闭左侧广告
        toclosel() {
            this.leftAd = 0;
        },
        // 关闭右侧广告
        tocloser() {
            this.rightAd = 0;
        },
        toTongzhi() {
            // http://192.168.1.25:8082/#/xqNews?id=14
            // console.log("1", this.catelist);
            var index;
            for (var i in this.catelist) {
                if (this.catelist[i].id == 14) {
                    index = i;
                }
            }
            this.$router.push({
                path: "/xqNews",
                query: {
                    id: 14,
                    index: index,
                    dhid: 35,
                },
            });
        },
        toleftAd(url) {
            window.open(url);
        },
        torightAd(url) {
            window.open(url);
        },
    },
    mounted() {
        // this.act = false;
        var xhr = new XMLHttpRequest();
        xhr.open("GET", "https://www.gov.cn/pushinfo/v150203/pushinfo.js", false); // 文件路径
        xhr.overrideMimeType("text/html;charset=utf-8"); // 默认为utf-8
        xhr.send(null);
        // 获取文件信息(得到的数据是String)
        //  console.log("111",xhr.responseText);
        var str = xhr.responseText;
        str = str.replaceAll('document.writeln("', "");
        str = str.replaceAll('");', "");
        // console.log(str);
        this.contents = str;
        //  $("#gwy").html(str)
        //  setTimeout(function(){
        //     $("#gwy").html(this.contents)
        //   },300)
    },
    updated() {
        console.log("updated");
        if (localStorage.getItem("changeRecruitScrollY")) {
            let recruitScrollY = localStorage.getItem("changeRecruitScrollY");
            console.log("recruitScrollY", recruitScrollY);
            window.scroll(0, recruitScrollY);
            localStorage.removeItem("changeRecruitScrollY");
        } else {
            window.scroll(0, 0);
        }
        if (this.isFirst == true) {
            return;
        }
        this.timer = setTimeout(function () {
            var mySwiper = new Swiper(".navSwiper", {
                // cssMode: true,
                // mousewheel: true,
                // keyboard: true,
                slidesPerView: 4,
                spaceBetween: 20,
                slidesPerGroup: 1,
                loop: true, // 循环模式选项
                // loopFillGroupWithBlank: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                // 前进后退按钮
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
            var mySwiper3 = new Swiper(".daoSwiper", {
                // cssMode: true,
                // mousewheel: true,
                // keyboard: true,
                slidesPerView: 5,
                spaceBetween: 20,
                slidesPerGroup: 1,
                loop: true, // 循环模式选项
                // loopFillGroupWithBlank: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                // 前进后退按钮
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
            var mySwiper2 = new Swiper(".mySwiper", {
                // cssMode: true,
                // mousewheel: true,
                // keyboard: true,
                slidesPerView: 3,
                spaceBetween: 30,
                slidesPerGroup: 1,
                loop: true, // 循环模式选项
                // loopFillGroupWithBlank: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                // 前进后退按钮
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
            this.isFirst = true;
        }, 200);
    },
    beforeRouteLeave(to, from, next) {
        let position = window.scrollY; //记录离开页面的位置
        console.log("position", position);
        if (position == null) position = 0;
        localStorage.setItem("changeRecruitScrollY", position);
        next();
    },
    // watch: {
    // $route(to, from) {
    // console.log("watchindex");
    // return;
    // let recruitScrollY = localStorage.getItem("changeRecruitScrollY");
    // console.log("recruitScrollY", recruitScrollY);
    // window.scroll(0, recruitScrollY);
    // if (from.name == "home") {
    //   let position = window.scrollY; //记录离开页面的位置
    //   console.log("position", position);
    //   if (position == null) position = 0;
    //   localStorage.setItem("changeRecruitScrollY", position);
    // }
    // if (to.name == "home") {
    //   let recruitScrollY = localStorage.getItem("changeRecruitScrollY");
    //   console.log("recruitScrollY", recruitScrollY);
    //   window.scroll(0, recruitScrollY);
    //   localStorage.removeItem("changeRecruitScrollY");
    // }
    // }
    // }
    // activated() {
    //   if(this.act == true){
    //     console.log("activated");
    //     this.isFirst = false;
    //     clearTimeout(this.timer);
    //     this.timer =null;
    //     this.$forceUpdate();
    //   }else{
    //     return;
    //   }
    // },
    // deactivated() {
    //   this.act = true;
    // }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navList {
    overflow: hidden;
}

.gonggao {
    position: relative;
    display: flex;
    width: 100%;
    height: 0.4rem;
    color: #666;
    font-size: 0.09rem;
    align-items: center;
    padding: 0.1rem 0;
}

.ico-horn {
    display: flex;
    width: 0.74rem;
    height: 0.2rem;
    justify-content: center;
    align-items: center;
}

.ico-horn .icon {
    width: 0.74rem;
    height: 0.2rem;
}

/* 以下代码与滚动相关 */
.marquee-wrap {
    position: relative;
    display: flex;
    overflow: hidden;
    width: 100%;
    height: 100%;
}

.marquee-box {
    position: absolute;
    top: 50%;
    display: flex;
    white-space: nowrap;
    transform: translateY(-50%);
}

.marquee-list {
    margin-right: 0.43rem;
    cursor: pointer;
}

/* 此处“px”方便回到起点 */
.marquee-list span {
    color: #ffe17b;
    font-weight: 700;
}

/* 轮播图 */
.mySwiper {
    width: 100%;
    height: 1.72rem;
    position: relative;
}

.navSwiper {
    width: 100%;
    height: 0.7rem;
    position: relative;
}

.daoSwiper {
    width: 100%;
    height: 0.36rem;
    position: relative;
}

.swiper-slide {
    font-size: 0.08rem;
    color: #666;
}

.swiper-slide .pic {
    display: block;
    width: 1.53rem;
    height: 0.78rem;
    object-fit: cover;
}

.swiper-slide .pic img {
    width: 100%;
    height: 100%;
}

.mySwiper .swiper-button-next,
.mySwiper .swiper-button-prev {
    color: rgba(250, 250, 250, 0.9);
    background-color: rgba(0, 0, 0, 0.5);
    width: 0.17rem;
    height: 0.46rem;
}

.navSwiper .swiper-button-next,
.navSwiper .swiper-button-prev {
    /* color: rgba(250, 250, 250, 0.9); */
    /* background-color: rgba(0, 0, 0, 0.5); */
    /* width: 0.17rem; */
    /* height: 0.46rem; */
}

.swiper-button-next {
    right: 0;
}

.swiper-button-prev {
    left: 0;
}

.swiper-button-prev:after,
.swiper-container-rtl .swiper-button-next:after {
    font-size: 0.18rem;
}

.swiper-button-next:after,
.swiper-container-rtl .swiper-button-prev:after {
    font-size: 0.18rem;
}

.navSwiper .swiper-slide img {
    width: 1.48rem;
    height: 0.63rem;
}

/* 喜迎二十大 */
.xiying {
    position: absolute;
    right: 1rem;
    top: 0.05rem;
    z-index: 10;
}

.xiying span {
    color: #0081df;
    font-size: 0.09rem;
    font-weight: 600;
}

#gwy /deep/ul {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
}

#gwy /deep/ul li {
    width: 47%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.03rem;
    position: relative;
    padding-left: 0.15rem;
}

/* /statics/image/index/dian.png */
#gwy /deep/ul li::before {
    position: absolute;
    left: 0;
    content: " ";
    background: url(/statics/image/index/dian.png) no-repeat;
    background-size: 0.05rem;
    width: 0.05rem;
    height: 0.05rem;
}

#gwy /deep/ul li span {
    color: #666;
}

#gwy /deep/ul li a {
    width: 1.53rem;
    font-size: 0.08rem;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    color: #666;
}

#gwy /deep/ul li:nth-of-type(n+13) {
    display: none;
}
</style>
